// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"b3def7bd","122":"83e04a71"}[chunkId] + ".chunk.css";
};